/* unplugin-vue-components disabled */import script from "./SupportTrendFull.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportTrendFull.vue?vue&type=script&setup=true&lang=js"

import "./SupportTrendFull.vue?vue&type=style&index=0&id=fd0f4634&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd0f4634"]])

export default __exports__